import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSorting, stableSort } from '../../../../util/TableUtils'
import { useQueryParams } from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import EnhancedTableHead from '../../../components/TableHead'
import {
  fetchServiceCategory,
  remove,
} from '../../../service-category/ServiceCategoryActions'
import { StyledTableCellBody } from '../../../../components/hooks/BaseTableComponents'
import { Box, Grid } from '@material-ui/core'
import colors from '../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiDelete, mdiNoteEditOutline } from '@mdi/js'
import ModalServiceCategory from './Modal'
import Pagination from '../../../../components/hooks/BasePagination'
import { useHistory, useLocation } from 'react-router-dom'
import BasePopUp from '../../../../components/hooks/BasePopUp'

function createData(id, name, status, color, cashback_conversion) {
  return { id, name, status, color, cashback_conversion }
}

const headCells = [
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Categoria',
  },
  {
    id: 'cashback_conversion',
    numeric: true,
    disablePadding: false,
    label: 'Conversão de Cashback',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
    align: 'center',
  },
]

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  tableStickHeader: {
    maxHeight: 'calc(100vh - 200px)',
    marginTop: '1.5em',
  },
  status: {
    textAlign: 'center',
    fontSize: '14p',
    borderRadius: '10px',
    padding: '4px 16px',
    maxWidth: '80px',
    backgroundColor: colors.graylight,
    color: '#000',
  },
  statusAtivo: {
    color: '#FFFF',
    backgroundColor: colors.secondary,
  },
  retangleColor: {
    width: '18px',
    height: '18px',
    borderRadius: '2px',
  },
}))

export const List = ({ classes }) => {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate } = usePermissions()
  const items = useSelector(state => state.serviceCategory.items)
  const meta = useSelector(state => state.serviceCategory.meta)

  const styles = useStyles()

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('value')
  const [selected, setSelected] = useState([])

  const [open, setOpen] = useState(false)
  const [editId, setEditId] = useState()

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [categoryToDelete, setCategoryToDelete] = useState(null)

  const handleClose = () => {
    setOpen(!open)
  }

  const rows = []

  items.map(item => {
    rows.push(
      createData(
        item.id,
        item.name,
        item.status_text,
        item.color,
        item.cashback_conversion
      )
    )
  })

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setCategoryToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (categoryToDelete) {
      dispatch(remove(categoryToDelete))
      dispatch(
        fetchServiceCategory({
          ...filters,
          page: filters?.page || 1,
          rows: filters?.rows || 10,
        })
      )
      setOpenDeleteModal(false)
      setCategoryToDelete(null)
    }
  }

  return (
    <>
      <TableContainer className={classes?.tableStickHeader}>
        <Table
          className={classes?.table}
          aria-labelledby="Tabela de Categorias de Serviços"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
            headCells={headCells}
            renderFirstTH={false}
          />
          <TableBody>
            {stableSort(rows, getSorting(order, orderBy)).map(row => {
              return (
                <TableRow hover tabIndex={-1} key={row.id}>
                  <StyledTableCellBody>{row.name}</StyledTableCellBody>

                  <StyledTableCellBody align="center">
                    {row.cashback_conversion
                      ? `${row?.cashback_conversion}`
                      : '-'}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {canUpdate('cashback-conversao', permissionUser) && (
                      <IconButton
                        aria-label="edit"
                        onClick={() => {
                          handleClose()

                          setEditId(row.id)
                        }}
                      >
                        <Icon path={mdiNoteEditOutline} size={1} />
                      </IconButton>
                    )}
                  </StyledTableCellBody>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={meta?.per_page}
        rows={meta?.total}
        page={meta?.current_page}
        from={meta?.from}
        to={meta?.to}
        handleChangePage={onMovePage}
      />

      <ModalServiceCategory
        isEdit
        id={editId}
        open={open}
        handleClose={handleClose}
      />

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Categoria de Serviço"
        message="Deseja realmente excluir esta categoria de serviço?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}
